import React, { type ComponentProps, type ReactNode } from "react";
import cx from "classnames";
import { Badge } from "@picklebet/ui";

import * as styles from "./TopBar.module.scss";

const Root = ({ className, ...props }: ComponentProps<"header">) => (
  <header className={cx(styles.root, className)} {...props} />
);

const Leading = ({ className, ...props }: ComponentProps<"div">) => (
  <div className={cx(styles.leading, className)} {...props} />
);

const Trailing = ({ className, ...props }: ComponentProps<"div">) => (
  <div className={cx(styles.trailing, className)} {...props} />
);

type ActionProps = Omit<ComponentProps<"button">, "children"> & {
  icon: ReactNode;
  badge?: number | string;
  active?: boolean;
};

const Action = ({ icon, badge, active, className, ...props }: ActionProps) => (
  <button
    type="button"
    data-active={active || undefined}
    className={cx(styles.action, className)}
    {...props}
  >
    <span className={styles.icon} aria-hidden>
      {icon}
    </span>
    {badge !== undefined && (
      <Badge color="danger" className={styles.badge}>
        {badge}
      </Badge>
    )}
  </button>
);

export const TopBar = Object.assign(Root, { Leading, Trailing, Action });
